<template>
  <div :class="borderColor" class="bg-white absolute inset-0 p-10">
    <div class="absolute inset-8">
      <div
          class="absolute inset-2 flex flex-col items-center justify-evenly overflow-hidden">

        <div class="square relative w-10/12 rounded-full" :class="classes">
          <stars-background-layer/>
          <zodiac-sign/>
        </div>

        <div id="text" class="flex flex-col items-center py-5 px-10 justify-center text-black">
          <div class="title leading-loose text-5xl font-bold " style="font-family: 'Dancing Script'">
            {{ this.$root.print.title }}
          </div>
          <div class="subtitle text-2xl">{{ this.$root.print.subtitle }}</div>
          <div class="tagline text-lg">{{ this.$root.print.tagline }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BaseLayer from "../BaseLayer";
import TitleDescriptionBlock from "../TitleDescriptionBlock";
import StarsBackgroundLayer from "../../StarsBackgroundLayer";
import ZodiacSign from "../../ZodiacSign";

export default {
  name: "DefaultZodiacLayer",
  components: {
    ZodiacSign,
    StarsBackgroundLayer,
    TitleDescriptionBlock
  },
  extends: BaseLayer,

  computed: {
    celestialSvgUrl() {
      return `/img/editor/zodiac/zodiac-2/${this.$root.print.zodiac}.svg`
    },
    styles() {

      const minWidth = Math.min(
          this.$root.posterSize.height,
          this.$root.posterSize.width,
      )

      const color = this.$root.print.color;

      const styles = {
        'background-image': `url('/img/editor/zodiac/stars.svg')`,
        width: (minWidth * 0.75) + 'px'
      }

      if (this.$root.print.orientation === 'horizontal') {
        styles.width = (minWidth * 0.65) + 'px';
        styles.height = (minWidth * 0.65) + 'px';
      }

      return styles
    },
    classes() {
      const color = this.$root.print.color;
      return this.$root.colors[color].color;
    },
    posterBackgroundClasses() {
      const color = this.$root.print.color;
      return this.$root.colors[color].bg;
    },
    borderColor() {
      const color = this.$root.print.color;
      return [
        this.$root.colors[color].border
      ];
    },
  },

  watch: {
    '$root.print.zodiac': function () {
      const zodiac = this.$root.zodiacSigns[this.$root.print.zodiac];
      console.log(this.$root.zodiacSigns)
      console.log(zodiac)

      this.$root.print.tagline = zodiac.nl
      this.$root.print.tagline = zodiac.nl
    }
  }
}
</script>

<style scoped>
* {
  pointer-events: none;
}

#circle {
  position: relative;
  border-radius: 100%;
  /*width: 100%;*/
  /*max-height: 500px;*/
  /*box-shadow: 0 0 0 2000px #FFF;*/
}

.square:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

</style>
